import {
  DuviSharedAdminButton as Button,
  DuviSharedAdminIcon as Icon,
  DuviSharedAdminTestIds,
} from "@duvi-agency/ui";
import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminAuditLog } from "./use-duvi-core-admin-audit-log";
import { DuviCoreAdminAuditLogView } from "./duvi-core-admin-audit-log-view";

export function DuviCoreAdminAuditLog() {
  const state = useDuviCoreAdminAuditLog();

  return (
    <DuviCoreAdminAppShell
      title="Audit log"
      subtitle="All platform admin actions"
      breadcrumbs={["Platform", "Audit Log"]}
      activeMenuItem="Audit Log"
      headerActions={
        <Button
          variant="secondary"
          leftIcon={<Icon name="download" size={15} />}
          onClick={state.handleExportCsv}
          data-testid={DuviSharedAdminTestIds.auditExportCsv}
        >
          Export CSV
        </Button>
      }
    >
      <DuviCoreAdminAuditLogView {...state} />
    </DuviCoreAdminAppShell>
  );
}
